import { manualAuthAxiosCall } from "./axios.services";
const token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MDIxNzMyMGU0ZDViOTdiMzUxNTAzZjQiLCJlbWFpbCI6InRAbWFpbC5jb20iLCJpYXQiOjE2MTI4MDUxOTEsImV4cCI6MTYyMTQ0NTE5MX0.SRvuXMfIFMMzEtfsboulzOGOTbVEHFr-qddzsdxYmR0";

export const notarizeDocument = (doc) => {
  const body = new FormData();
  body.append("file", doc);
  return manualAuthAxiosCall(token, "/api/documents/notarize", {
    method: "POST",
    body,
  });
};

export const validateDocument = (doc, isFile) => {
  let body;
  if (isFile) {
    body = new FormData();
    body.append("file", doc);
  } else {
    body = { transactionHash: doc };
  }
  return manualAuthAxiosCall(token, "/api/documents/validate", {
    method: "POST",
    body,
  });
};
